module.exports = __webpack_public_path__ + "static/media/experience-background-mobile.21d7a35d.webp";